module.exports = __webpack_public_path__ + "images/application/i-lock-grey-7a563da7.svg";